import React from 'react';
import './WelcomeDialog.css';

interface WelcomeDialogProps {
  onStart: () => void;
  onSkip: () => void;
}

export const WelcomeDialog: React.FC<WelcomeDialogProps> = ({ onStart, onSkip }) => {
  return (
    <div className="welcome-overlay">
      <div className="welcome-box">
        <p className="welcome-greeting">Welcome to</p>
        <h1 className="welcome-title">Wesley's Portfolio</h1>
        <p className="welcome-text">
          This isn't your typical portfolio. I built it as a
          little world you can walk around and explore.
        </p>
        <p className="welcome-text">
          Each building holds a different piece of my story.
          Use WASD to move and visit them all.
        </p>
        <p className="welcome-hint">Sound on for the full experience</p>
        <div className="welcome-actions">
          <button className="welcome-btn" onClick={onStart}>
            Let's Go
          </button>
          <button className="welcome-btn-skip" onClick={onSkip}>
            Quick Tour
          </button>
        </div>
      </div>
    </div>
  );
};
